import React, { useEffect } from 'react'
import CustomCard from './CustomCard'
import CardHeader from './CardHeader'
import { CardContent, Collapse } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledCardContent = styled(CardContent)(({ theme, color }) => ({
    padding: '0px',
    backgroundColor: color ? color : '#fbfbfd',
}))

const Card = (props) => {
    const {
        cardTitle,
        collapsible,
        children,
        icon,
        headerColor,
        color,
        expanded,
        disableExpand,
        colorCode,
        onExpandChange,
        isTitleJsx,
        disabled,
    } = props
    const [_expanded, setExpanded] = React.useState(expanded)

    useEffect(() => {
        if (disableExpand) setExpanded(false)
        if (expanded) setExpanded(true)
    }, [disableExpand, expanded])

    const handleExpandClick = () => {
        setExpanded(!_expanded)
        if (onExpandChange) {
            onExpandChange(!_expanded)
        }
    }

    return (
        <CustomCard disabled={disabled}>
            <CardHeader
                isTitleJsx={isTitleJsx}
                colorCode={colorCode}
                cardTitle={cardTitle}
                handleExpandClick={
                    disableExpand
                        ? () => {
                              //do nothing
                          }
                        : handleExpandClick
                }
                expanded={_expanded}
                collapsible={collapsible}
                icon={icon}
                headerColor={headerColor}
                fontColor="black"
            ></CardHeader>
            {collapsible ? (
                <Collapse in={_expanded} timeout={400} unmountOnExit>
                    <StyledCardContent color={color}>
                        {children}
                    </StyledCardContent>
                </Collapse>
            ) : (
                <StyledCardContent color={color}>{children}</StyledCardContent>
            )}
        </CustomCard>
    )
}

Card.defaultProps = {
    expanded: false,
}

Card.CardHeader = CardHeader

export default Card
